const getFileNameFromUrl = (url, index) => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;

    const filename = pathname.split('/').pop();

    if (filename && filename.includes('-') && filename.includes('.')) {
      const extension = filename.split('.').pop();
      return `Image ${index + 1}.${extension}`;
    }

    return filename || 'attachment';
  } catch {
    return 'attachment';
  }
};

export default getFileNameFromUrl;
